import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const BackButtonLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }: { theme: any }) => theme.text.title};
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

interface NavigationBackButtonProps {
  onClick: () => void;
  children?: ReactNode;
}

export const NavigationBackButton = ({ onClick, children }: NavigationBackButtonProps) => {
  const { t } = useTranslation();
  return (
    <BackButtonContainer>
      <BackButtonLink onClick={onClick}>
        <img src='/chevron-left.svg' alt={t('common.back')} height={48} width={9} />
        {children ?? t('common.back')}
      </BackButtonLink>
    </BackButtonContainer>
  );
};
